import { render, staticRenderFns } from "./TerminalRequestCrossSellingView.vue?vue&type=template&id=e363b70c&scoped=true&"
import script from "./TerminalRequestCrossSellingView.vue?vue&type=script&lang=js&"
export * from "./TerminalRequestCrossSellingView.vue?vue&type=script&lang=js&"
import style0 from "./TerminalRequestCrossSellingView.vue?vue&type=style&index=0&id=e363b70c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e363b70c",
  null
  
)

export default component.exports